import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
import MetaInfo from '@common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.SAAS_PLATFORM_DEVELOPMENT)

// ── Section 1 — What We Offer cards ──────────────────────────────────
const SCALABLE_PLATFORM_CARDS = [
  { title: 'Product Discovery & Definition',     desc: 'Translate your business idea into a clear product vision, functional requirements, user journeys, feature priorities, and a practical development roadmap.' },
  { title: 'Modern Product Experiences',      desc: 'Create intuitive and engaging experiences across web and mobile with responsive interfaces, reusable components, design systems, and user-focused workflows.' },
  { title: 'Scalable SaaS Architecture',           desc: 'Build flexible architectures designed to support growing users, data, features, integrations, and workloads without compromising performance or reliability.' },
  { title: 'Multi-Tenant SaaS Development',  desc: 'Develop secure and flexible multi-tenant platforms that can serve multiple customers while maintaining appropriate data isolation, access controls, configuration, and scalability.' },
  { title: 'API-First & Integration-Ready Products', desc: 'Design products with well-structured APIs that make it easier to connect third-party services, business systems, mobile applications, and future product capabilities.' },
  { title: 'Continuous Product Evolution',   desc: 'SaaS products are never truly finished. We support continuous enhancement through new features, integrations, performance improvements, technology upgrades, and product modernization.' },
]

// Section 2 
const OUR_SAAS_PRODUCT = [
  {
    icon: 'fa-cloud',
    title: 'SaaS Platform Development',
    desc: 'Build cloud-ready SaaS platforms with scalable architecture, secure user management, flexible configurations, and subscription-ready foundations.',
  },
  {
    icon: 'fa-building',
    title: 'B2B & Enterprise Products',
    desc: 'Develop sophisticated products for businesses, teams, partners, and enterprise users with role-based access, workflows, integrations, and reporting.',
  },
  {
    icon: 'fa-mobile-screen-button',
    title: 'Consumer Digital Products',
    desc: 'Create engaging digital products focused on usability, performance, personalization, and seamless customer experiences.',
  },
  {
    icon: 'fa-rocket',
    title: 'Product MVP Development',
    desc: 'Validate product concepts quickly with focused MVP development that establishes the core product experience and technology foundation.',
  },
  {
    icon: 'fa-arrows-rotate',
    title: 'Product Modernization',
    desc: 'Modernize existing products by improving architecture, user experience, performance, technology stacks, and scalability.',
  },
  {
    icon: 'fa-plug',
    title: 'SaaS Integrations & APIs',
    desc: 'Connect products with payment gateways, CRMs, ERP systems, communication platforms, analytics tools, AI services, and other business ecosystems.',
  },
]
const ON_DEMAND_LIFECYCLE = ['Discover', 'Define', 'Design', 'Build', 'Launch', 'Measure', 'Evolve']



export default function SaasPlatformDevelopment() {
  

  return (
    <> 
    {/* <MetaInfo
        title="SaaS & Product Development | CruxBytes"
        description="Turn your product idea into a scalable SaaS platform. CruxBytes builds multi-tenant SaaS, MVPs and digital products with modern architecture and APIs."
        keywords="SaaS development, product development, multi-tenant SaaS, MVP development, SaaS platform development, API-first products, product modernization, CruxBytes"
      /> */}
       <MetaInfo
      title={label}
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- Software Development -</div> */}
             <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* SaaS & Product Development */}
              {label}
              </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Build scalable SaaS platforms designed for growth and flexibility. */}
             {pageDesc}
             </p>
             
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>
         {/* section 1 */}
      <section className="bg-linear-gradient-light section-py text-center" >
      <div className="container">
           

        {/* Row 2 — */}
         <p data-aos="fade-up">
             Turn your product vision into a robust digital platform built for real users, continuous innovation, and long-term growth. A product that works for its first hundred users may not work the same way for its next hundred thousand. We build with growth in mind from the beginning—using modular architecture, reusable components, scalable databases, API-driven development, cloud technologies, automated testing, security practices, and reliable deployment processes. This creates a technology foundation that can evolve without forcing the product to start over.
         </p>
         <p  data-aos="fade-up" data-aos-delay={100}>
             CruxBytes helps businesses build SaaS products and digital platforms from concept to launch and beyond. We combine product thinking, modern engineering practices, intuitive experiences, and scalable architecture to create products that can evolve with changing market and customer needs
         </p>
 <h6 className="text-highlight pt-4" data-aos="fade-up" data-aos-delay={200}>From Product Idea to Scalable Platform</h6>
         <p className="pt-3" data-aos="fade-up" data-aos-delay={200}>
             Building a successful SaaS product requires more than developing features. It requires the right product strategy, technology foundation, user experience, architecture, and engineering practices to support continuous growth.
         </p>
         <p data-aos="fade-up" data-aos-delay={200}>
             We bring these elements together to help transform product ideas into reliable, market-ready digital products.
         </p>
                
        <div className="wcs-grid wcs-grid--3 pt-4">
          {SCALABLE_PLATFORM_CARDS.map((card, i) => (
            <div
              key={card.title}
              className="wcs-card-offer"
              data-aos="fade-up"
              data-aos-delay={(i % 3) * 80}
            >
              {/* <i className={`${card.icon} wcs-icon`} aria-hidden="true" /> */}
              <h3 className="wcs-offer-title">{card.title}</h3>
              <p className="wcs-offer-desc">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
     <p className="text-highlight pt-4" data-aos="fade-up" >
                From the first product idea to a platform built for scale, CruxBytes helps turn technology into a long-term product advantage.
              </p>
              <div className="text-center pt-4">
                <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-left">
                  Get Started
                </Button>
              </div>
    </section>

     {/* ── Section 2 */}
        <section className="sc-code-section section-py" aria-labelledby="uiux-delivers-heading">
          <svg className="sc-code-curve sc-code-curve--left" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="0" cy="0" r="100" stroke="rgba(255,255,255,0.5)" strokeWidth="1" fill="none" />
            <circle cx="0" cy="0" r="180" stroke="rgba(255,255,255,0.5)" strokeWidth="1" fill="none" />
            <circle cx="0" cy="0" r="260" stroke="rgba(255,255,255,0.5)" strokeWidth="1" fill="none" />
          </svg>
          <svg className="sc-code-curve sc-code-curve--right" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="400" cy="0" r="100" stroke="rgba(255,255,255,0.5)" strokeWidth="1" fill="none" />
            <circle cx="400" cy="0" r="180" stroke="rgba(255,255,255,0.5)" strokeWidth="1" fill="none" />
            <circle cx="400" cy="0" r="260" stroke="rgba(255,255,255,0.5)" strokeWidth="1" fill="none" />
          </svg>

          <div className="container">
            <div className="sc-code-header" data-aos="fade-up">
              <h2 id="uiux-delivers-heading" className="sc-code-heading">
                Our SaaS & Product Development Capabilities
              </h2>
            </div>

            <div className="wcs-grid">
              {OUR_SAAS_PRODUCT.map((item, i) => (
                <div
                  key={item.title}
                  className="wcs-card bg-white"
                  data-aos="fade-up"
                  data-aos-delay={i * 80}
                >
                  {i > 0 && <div className="sc-code-divider" aria-hidden="true" />}
                  <i className={`fa-solid ${item.icon} wcs-icon`} aria-hidden="true" />
                  <h3 className="wcs-title">{item.title}</h3>
                  <p className="wcs-desc">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>


        {/* Section3 */}
 <section
      id="strengths"
      className="about-us-section section-py"
      aria-labelledby="strengths-heading"
      data-aos="fade-up"
    >   <div className='container'> 
     
  <div className="sc-tm-row pt-4">

      <div className="sc-tm-content" data-aos="fade-left">
       <h2 id="impact-heading" >
            <span className="impact-heading-dark">Designed Around the</span>
            <span className="impact-heading-light">Product Lifecycle</span>
          </h2>
          <span className='text-highlight-light'>Build Once. Evolve Continuously. Launching the product is only the beginning.</span>
      </div>
      <div  data-aos="fade-right">
        <div className="contact-form-wrap bg-brand-light">
          
              <p >Our product development approach supports the complete journey—from validating an initial idea and building an MVP to scaling an established SaaS platform. As your product evolves, we can help introduce new capabilities, improve existing experiences, modernize technology, and prepare the platform for the next stage of growth.</p>
               <ol className="step-flow" role="list" aria-label="Application development lifecycle">
                        {ON_DEMAND_LIFECYCLE.map((step) => (
                          <li key={step} className="step-flow-item-circle">
                            <span className="step-flow-label-circle">{step}</span>
                          </li>
                        ))}
                      </ol>
              <p className='pt-4'>We help create the technology foundation required for continuous product evolution—whether that means adding new modules, expanding into new markets, supporting more customers, integrating new technologies, or introducing AI-powered capabilities.</p>
              <p > Your product should not be limited by the technology behind it.With the right combination of product thinking, user experience, engineering, and scalable architecture, your SaaS platform can continuously adapt to customers, markets, and new opportunities.</p>
        </div>
      </div>

    </div>
 
    
    </div>  
   
        
    </section>
         <TransformBanner />
         </main>
         </>
  )
}